const LOGO_ICON = "https://customer-assets.emergentagent.com/job_0676d164-8c9a-42e2-9031-3d27302005b9/artifacts/44v60qf2_IMG_20260121_182446.png";
const LOGO_FULL = "https://customer-assets.emergentagent.com/job_0676d164-8c9a-42e2-9031-3d27302005b9/artifacts/35qgt33f_bhumi-logo-png.png";

const BhumiLogo = ({ size = 'md', showText = true, className = '', isDark = false, variant = 'icon' }) => {
  const sizes = {
    sm: { icon: 'h-8 w-8', full: 'h-10', text: 'text-lg' },
    md: { icon: 'h-12 w-12', full: 'h-14', text: 'text-2xl' },
    lg: { icon: 'h-16 w-16', full: 'h-20', text: 'text-4xl' },
    xl: { icon: 'h-20 w-20', full: 'h-24', text: 'text-5xl' },
  };

  const s = sizes[size] || sizes.md;

  if (variant === 'full') {
    return (
      <div className={`flex items-center ${className}`}>
        <img
          src={LOGO_FULL}
          alt="Bhumi"
          className={`${s.full} w-auto object-contain`}
        />
      </div>
    );
  }

  const iconSrc = LOGO_ICON;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <img
        src={iconSrc}
        alt="Bhumi"
        className={`${s.icon} object-contain`}
      />
      {showText && (
        <span className={`${s.text} font-bold ${isDark ? 'text-white' : 'text-[#2E7D32]'}`}>
          ভূমি
        </span>
      )}
    </div>
  );
};

export default BhumiLogo;
export { LOGO_ICON, LOGO_FULL };
